import router from './router'
import store from './store'
import {
  Toast
} from 'vant'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  getToken
} from '@/utils/auth'

NProgress.configure({
  showSpinner: false
})

const whiteList = ['/login','/jump', '/reg', '/agreement', '/foundpwd', '/editpwd', '/appDownload', '/agreementView', '/videoPlay']
//'/home', '/apps', '/news', '/my', '/appsDetail', '/newsDetail', '/feedback', '/notice', '/noticeDetail', '/editInfo',

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    /* has token*/
    if (to.path === '/login') {
      // 登录页场景下，先校验 token 是否有效，有效才跳转首页
      store.dispatch('GetProfile').then(() => {
        next({
          path: '/'
        })
        NProgress.done()
      }).catch(() => {
        store.dispatch('LogOut').finally(() => {
          next()
          NProgress.done()
        })
      })
    } else {
      // 判断当前用户是否已拉取完user_info信息，使用userId或user对象来判断
      if (!store.getters.userId || !store.getters.user) {
        store.dispatch('GetProfile').then(() => {
          // 获取用户会员状态
          // store.dispatch('CheckUserFeatures');
          
          next() // hack方法 确保addRoutes已完成
        }).catch(err => {
          store.dispatch('LogOut').then(() => {
            Toast.fail(err)
            next({
              path: '/'
            })
          })
        })
      } else {
        next()
      }
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      // 如果有code 参数 单独放在外面
      if (to.query.code) {
        next(`/login?redirect=${to.fullPath}&code=${to.query.code}`)
      }else {
        next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      }
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;

  // 兼容IE
  window.scrollTo(0, 0);

  NProgress.done()
})